<template>
  <div id="puzzle-solution">
    <vue-markdown>The images all match Android version names:
    GINGERBREAD, ECLAIR, NOUGAT, OREO, MARSHMALLOW, ECLAIR. 
      
    Take the first letters of each word to get the answer, **GENOME**.
    </vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
  components: {
    VueMarkdown
  }  
}
</script>